import React, { useEffect } from "react";
import { inject } from "mobx-react";
import { Alert } from "@op/opds.opux";
import { Message, useMessage } from "react-message-context";
import { Redirect } from "react-router-dom";
import { focusAtElement } from "../../utils/commonUtils";
import ActionByCustomerType from "../ActionByCustomerType";

const QuitPage = ({ FeedbackStore }) => {
  const title = useMessage("quit.title")();

  useEffect(() => {
    focusAtElement("#ROF-quit");
    window.disableLinkInterruption();
  }, []);

  if (!FeedbackStore.isDirty) {
    return <Redirect to="/" />;
  }

  return (
    <div>
      <Alert
        id="ROF-quit"
        type="positive"
        title={title}
        tabIndex={-1}
        contentType="static"
        role="status"
      >
        <p>
          <Message id="quit.body" />
        </p>
      </Alert>
      <ActionByCustomerType text="quit.link.frontpage" url="url.opfi" />
      <ActionByCustomerType
        text="quit.link.giveFeedback"
        url="url.giveFeedback"
      />
    </div>
  );
};

export default inject("FeedbackStore")(QuitPage);
